import { noOp } from 'common/Constants';
import React, { useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { ZIndex } from 'web-common/src/shared/styles';
import { ContentContainer, getArrowInlineColorStyles, InfoIcon, TriggerContainer } from './styles';
import { TooltipProps } from './types';

export const Tooltip: React.FC<React.PropsWithChildren<TooltipProps>> = ({
  className,
  isOpen,
  content,
  children,
  showArrow = true,
  showShadow,
  showInfoCircle,
  containerStyle,
  tooltipColor,
  tooltipMaxWidth,
  contentLocation,
  isDisabled = false,
  ...props
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const { isSmallScreen } = useScreenContext();

  if (isDisabled) {
    return <>{children}</>;
  }

  return (
    <Popover
      reposition
      isOpen={isOpen ?? isTooltipOpen}
      positions={['top', 'bottom', 'left', 'right']}
      onClickOutside={isSmallScreen ? () => setIsTooltipOpen(false) : noOp}
      contentLocation={contentLocation}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowSize={8}
          {...getArrowInlineColorStyles({ tooltipColor, showArrow })}>
          <ContentContainer showShadow={showShadow} tooltipColor={tooltipColor} tooltipMaxWidth={tooltipMaxWidth}>
            {content}
          </ContentContainer>
        </ArrowContainer>
      )}
      containerStyle={{
        zIndex: `${ZIndex.ModalContent}`,
        ...containerStyle,
      }}
      {...props}>
      <TriggerContainer
        className={className}
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={isSmallScreen ? noOp : () => setIsTooltipOpen(false)}
        onClick={isSmallScreen ? () => setIsTooltipOpen(true) : noOp}>
        {children}
        {showInfoCircle && <InfoIcon />}
      </TriggerContainer>
    </Popover>
  );
};
